<template>
  <div class="question-view-dialog" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>
      <div class="img-show">
        <div :class="['single', existImage.includes(idx) && 'disabled']" v-for="(item, idx) in imageList" :key="idx" :draggable="(item.image && !existImage.includes(idx)) ? 'true' : 'false'" @dragstart="dragstart($event, idx)">
          <img :src="item.image" v-if="item.image" alt=""> 
        </div>
      </div>
    </div>
    <div class="quest-img-dialog" :style="{backgroundImage: `url(${form.img_url || form.imgUrl})`}">
    </div>

  </div>
</template>

<script>
import ImgDrag from './imgDrag/imgDrag';
import {_debounce} from '@/utils/throttle.js'

export default {
  props: ['form', 'mode'],
  data() {
    return {
      image: '',
      topic: '',
      imageList: [],
      existImage: [],
      emptyBlock: [],

      drag: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: {},

      map: []
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)

      // 清空样式
      let blocks = document.querySelectorAll('.block-style')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].click()
      }
    },
    showTrueFalse() {
      let { form, recordQuestion } = this, answers = {},
      blocks = document.querySelectorAll('.block-style')
      form.answers.map(its => {
        let [value] = JSON.parse(its.value)
        if(value) answers[its['choice_id']] = value.value
      })
      
      console.clear()
      // console.log(answers)
      // 回显数据
      for(let i = 0; i < blocks.length; i++) { 
        let block = blocks[i],
        id = block.dataset.id
        if(recordQuestion[id]) block.style.backgroundImage = `url(${recordQuestion[id]})`
      }

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        id = block.dataset.id, url
        if(block.style.backgroundImage) {
          let blockImg = block.style.backgroundImage.match(/"(.+?)"/g)[0]
          url = blockImg.substring(1, blockImg.length - 1)
        }
        if(answers[id] == url) {
          block.classList.add('block-style-success')
        } else {
          block.classList.add('block-style-error')
        }
      }
    },
    addRegion() {
      this.drag.createBlock()
    },

    dragstart(e, idx) {
      e.dataTransfer.setData('info', idx)
    },
    sizeEvent() {
      // 获取quest-img宽高比例
      let imgDom = document.querySelector('.quest-img-dialog'),
      iWidth = imgDom.clientWidth,
      imgBl = iWidth / 833,
      iHeight = 500 * imgBl

      imgDom.style.height = iHeight + 'px'
      // 获取block-style宽高
      // let block = document.querySelectorAll('.block-style')
      for(let i = 0; i < this.map.length; i++) {
        let {width, height, x, y, uuid} = this.map[i], 
        block = imgDom.querySelector(`#${uuid}`),
        bl = imgBl * 500 / 300
        
        if(block) {
          block.style.width = `${width * bl}px`
          block.style.height = `${height * bl}px`
          block.style.top = `${y * bl}px`
          block.style.left = `${x * bl}px`
        }
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = {}
      this.existImage = []
      this.imageList = []

      this.drag = new ImgDrag({
        plate: '.quest-img-dialog',
        useType: 'view',
      })
      
      let content = JSON.parse(this.form.content)
      // console.log(content)
      this.map = []
      for(let i = 0; i < this.form.choices.length; i++) {
        let its = this.form.choices[i],
        imgList = content.imageList[i]
        // console.log(imgList)
        // if(imgList.image) {
          this.map.push({
            ...imgList,
            other: {
              id: its.id,
              position: its.position,
              type: its.type
            }
          })
        // } else {
        //   this.emptyBlock.push({
        //     ...imgList,
        //     other: {
        //       id: its.id,
        //       position: its.position,
        //       type: its.type
        //     }
        //   })
        // }
      }

      // 过滤未上传图片的区域
      content.imageList = content.imageList.filter(its => its.image && its)
      this.imageList = content.imageList

      // 将图片列表顺序打乱
      for(let i = 0; i < this.imageList.length; i++) {
        let random = Math.floor(Math.random() * this.imageList.length)

        // 替换位置
        if(random != i) {
          [this.imageList[i], this.imageList[random]] = [this.imageList[random], this.imageList[i]]
        }
      }

      // console.log(this.form)
      this.drag.echoBlock(this.map, this)
      // if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
      this.sizeEvent()
    }
  },
  created() {

  },
  mounted() {
    this.initData()

    window.onresize = _debounce(this.sizeEvent, 500)
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    flex: 1;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

    .img-show {
      width: 260px;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      margin-top: 10px;
    }

    .single {
      width: 100px;
      height: 100px;
      margin: 10px 10px 0 0;
      border-radius: 10px;
      // background-color: #f8ae64;
      box-shadow: 0 2px 3px 2px #ccc;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        user-select: none;
        -webkit-user-drag: none;
      }
    }

    .disabled {
      opacity: .4;
      cursor: not-allowed;
    }
  }
  .quest-img-dialog {
    width: 833px;/*width: 833px;*/
    height: 500px;
    background-color: #fff;
    background-size: 100% 100%;
    position: relative;
    .img-region {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        position: absolute;
        background-color: #fff;
        color: #333;
      }

      &:after, &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -50%;
        margin: auto;
        height: 1px;
        width: 200%;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:before {
        transform: rotateZ(-45deg);
      }
    }

    img {
      width: 100%;
      height: 100%;
      user-select: none;
      -webkit-user-drag: none;
    }

  }
}
</style>